mutation MovementTravelerDelete($input: MovementTravelerUpdateInput!) {
  movementTravelerUpdate(input: $input) {
    boolean
  }
}
